import React from 'react';
import { motion } from 'framer-motion';
import { toast } from 'sonner';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  fullWidth = false,
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    } else {
      toast.success('¡Redirigiendo al checkout seguro!');
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        bg-nutri-cta hover:bg-green-500 text-white font-bold uppercase tracking-wide 
        py-4 px-8 rounded-xl shadow-lg shadow-green-500/30 transition-colors
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-49">
      {children}
    </motion.button>;
}